import React, { useState, useEffect } from "react";
import { Col, Container, Row } from "react-bootstrap";
import "../../Style.css";
import AdminHeader from "../../common/Header";
import List from "../../components/listing/List";
import BreadCrumb from "../../components/breadcrumb/BreadCrumb";
import Api from "../../components/api/Api";
import { useSelector } from "react-redux";
import axios from "axios";
import Notification, {
  showToast,
} from "../../../components/common/notification/Notification";
import Tr from "../../components/tr/Tr";

const AllServices = () => {
  const loggedInUser = useSelector((state) => state.auth.user);
  const token = loggedInUser?.refreshToken;
  const baseUrl = process.env.REACT_APP_BASE_URL;
  
  const serviceApi = Api({
    url: "api/all/services/types",
  });


  const handleDelete = async (itemId) => {
    try {
      const response = await axios.delete(`${baseUrl}/api/all/services/types/delete/${itemId}`,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          }, 
        }
      );
      console.log(response);
      if (response.data.statusType === "SUCCESS") {
        setData(data.filter((item) => item.id !== itemId));
        showToast("All Services deleted successfully", {
          type: "success",
        });
      } else {
        console.error(
          "Error 'deleting' item. Server responded with status:",
          response.status
        );
      }
    } catch (error) {
      console.error("Error 'deleting' item:", error);
    }
  };

  const [data, setData] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const columns = [
    { displayName: "S.No.", render: (item, index) => index + 1 },
    { displayName: "Name", key: "name" },
    { displayName: "Descroption", key: "description" },
  ];
  
  const fetchData = async (pageNumber = 1) => {
    try {
      const responseData = await serviceApi.fetchData(pageNumber);
      console.log(responseData);
      console.log("your all services type is", responseData);
      setData(responseData.data.allServiceCategories);
      setTotalPages(responseData.data.totalPage);
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  useEffect(() => {
    fetchData(currentPage);
  }, [currentPage]);
  const handlePageChange = (page) => {
    setCurrentPage(page);
  };
  const initialValues = {};
  const breadcrumbItems = [
    { label: "", link: "/admin", icon: "fa-solid fa-house" },
    { label: "Master", link: "/user" },
    { label: "All Services", link: "/all-services", active: true },
  ];
  return (
    <>
      <Notification />
      <div className="content-body2">
        <Container>
          {/* Delete Alert */}
          <BreadCrumb items={breadcrumbItems} />
          <Row>
            <Col lg={3} md={4} sm={12}>
              <AdminHeader />
            </Col>
            <Col lg={9} md={8} sm={12}>
              {data?.length === 0 ? (
                <>
                  <Tr
                    columns={columns}
                    initialValues={initialValues}
                    title="No Services Type Found"
                    buttonName="Create"
                    btnLink="add-all-service-type"
                    titleHeader="All Services"
                  />
                </>
              ) : (
                <List
                  title="All Services"
                  data={data}
                  columns={columns}
                  button="Create"
                  route="all-services"
                  to="add-all-services"
                  handleDelete={handleDelete}
                  currentPage={currentPage}
                  totalPages={totalPages}
                  onPageChange={handlePageChange}
                />
              )}
            </Col>
          </Row>
        </Container>
      </div>
    </>
  );
};

export default AllServices; 